// **Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// **Utils Imports
import {
  getUserWorkspace,
  removeUserWorkspace,
  setUserWorkspace
} from '../../../utils/utils'

const localWorkspace = getUserWorkspace()

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState: {
    selectedWorkspace: localWorkspace || null,
    workspaces: [],
    workspaceTableFilters: { query: '', page: 0, pageSize: 10 }
  },
  reducers: {
    setWorkspaces(state, action) {
      state.workspaces = action.payload.workspaces
    },
    setSelectedWorkspace(state, action) {
      const workspace = action.payload.selectedWorkspace
      if (workspace) {
        setUserWorkspace(workspace)
      } else {
        removeUserWorkspace()
      }
      state.selectedWorkspace = workspace
    },
    setWorkspaceTableFilters(state, action) {
      state.workspaceTableFilters = action.payload
    },
    resetWorkspaceTableFilters(state) {
      state.workspaceTableFilters = { query: '', page: 0, pageSize: 10 }
    }
  }
})

export const {
  setWorkspaces,
  setSelectedWorkspace,
  setWorkspaceTableFilters,
  resetWorkspaceTableFilters
} = workspaceSlice.actions

export default workspaceSlice.reducer
